var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.3121 0.386719H7.7C3.104 0.386719 0.5 2.99072 0.5 7.58671V20.1868C0.5 24.7827 3.104 27.3867 7.7 27.3867H20.3121C24.908 27.3867 27.5 24.7827 27.5 20.1868V7.58671C27.5 2.99072 24.908 0.386719 20.3121 0.386719Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.40625 12.793C7.44142 14.4374 7.53988 17.25 7.55395 17.5602C7.60389 18.2234 7.85779 18.8937 8.25306 19.3663C8.80307 20.0296 9.48038 20.3257 10.425 20.3257C11.7303 20.3327 13.1694 20.3327 14.5669 20.3327C15.9701 20.3327 17.3317 20.3327 18.4817 20.3257C19.4129 20.3257 20.1113 20.0218 20.6543 19.3663C21.0495 18.8937 21.3034 18.2164 21.3393 17.5602C21.3534 17.2992 21.4237 14.2461 21.4659 12.793H7.40625Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9102 15.8205V16.7306C13.9102 17.0218 14.1465 17.2581 14.4377 17.2581C14.7288 17.2581 14.9652 17.0218 14.9652 16.7306V15.8205C14.9652 15.5293 14.7288 15.293 14.4377 15.293C14.1465 15.293 13.9102 15.5293 13.9102 15.8205Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1813 15.2373C13.111 15.4926 12.8655 15.6558 12.5997 15.6206C10.8055 15.3702 9.09073 14.7337 7.64327 13.7779C7.49487 13.6808 7.40625 13.5148 7.40625 13.3376V10.8998C7.40625 9.42285 8.61036 8.22155 10.0909 8.22155H11.4743C11.6066 7.20031 12.4717 6.40625 13.5281 6.40625H15.3441C16.3998 6.40625 17.2656 7.20031 17.3978 8.22155H18.7883C20.2646 8.22155 21.4659 9.42285 21.4659 10.8998V13.3376C21.4659 13.5148 21.3766 13.6801 21.2296 13.7779C19.7793 14.7379 18.0575 15.3773 16.2514 15.6269C16.2267 15.6305 16.2028 15.6319 16.1789 15.6319C15.9405 15.6319 15.7274 15.4708 15.6676 15.2345C15.5255 14.6746 15.017 14.2829 14.4325 14.2829C13.8403 14.2829 13.3375 14.6662 13.1813 15.2373ZM15.3441 7.46125H13.5281C13.0547 7.46125 12.6594 7.78478 12.5413 8.22155H16.3301C16.212 7.78478 15.8167 7.46125 15.3441 7.46125Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.c9f832a677f3d15a8ef8bb29f254c2d1.svg";
export { ForwardRef as ReactComponent };